export default "__VITE_ASSET__73ffbd9a__"